import api from "./api";
import SecureLS from "secure-ls";
import notification from "@/services/notification";
import _ from "lodash";

const ls = new SecureLS({
    encodingType: "rc4",
    isCompression: false,
    encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});

export default {
    isLogin() {
        return !!this.getUser();
    },

    isVerified() {
        return !!this.getOtpTokenId();
    },

    merchantUuid() {
        return this.getUser().merchant_uuid;
    },
    getUser() {
        return ls.get("user");
    },
    getToken() {
        return ls.get("token");
    },
    getHeader() {
        return { Authorization: this.getToken() };
    },
    getModuleAccess() {
        return ls.get("moduleAccess");
    },
    getMetas() {
        return ls.get("metas");
    },
    setUser(user) {
        ls.set("user", user);
    },
    setToken(token) {
        ls.set("token", token);
    },
    setHasPasswordUpdated(hasPasswordUpdated) {
        ls.set("hasPasswordUpdated", hasPasswordUpdated);
    },
    getHasPasswordUpdated() {
        return ls.get("hasPasswordUpdated");
    },
    setModuleAccess(moduleAccess) {
        ls.set("moduleAccess", moduleAccess);
    },
    setModuleAccessId(id) {
        ls.set("moduleAccessId", id);
    },
    setMetas(metas) {
        ls.set("metas", metas);
    },
    setEnabledTopUps(topups) {
        ls.set("enabledTopUps", topups);
    },
    setOnlineStoreVisibility(visibility) {
        ls.set("onlineStoreVisibility", JSON.stringify(visibility));
    },
    setWhitelistType(whitelist) {
        ls.set("whitelistType", whitelist);
    },
    getEnabledTopUps() {
        return ls.get("enabledTopUps");
    },
    getOnlineStoreVisibility() {
        return ls.get("onlineStoreVisibility");
    },
    getWhitelistType() {
        return ls.get("whitelistType");
    },
    setMerchantName(merchant) {
        ls.set("merchant", merchant);
    },
    setMerchantWebsite(website) {
        ls.set("merchantWebsite", website);
    },
    setPlanId(plan) {
        ls.set("planId", plan);
    },
    setCurrentStep(step) {
        ls.set("currentStep", step);
    },
    getCurrentStep() {
        return ls.get("currentStep");
    },
    getMerchantName() {
        return ls.get("merchant");
    },
    getMerchantWebsite() {
        return ls.get("merchantWebsite");
    },
    getPlanId() {
        return ls.get("planId");
    },
    getModuleAccessId() {
        return ls.get("moduleAccessId");
    },
    logout() {
        return new Promise((resolve, reject) => {
            api.post("merchant-auth-service/auth/logout", {
                uuid: this.getUser().uuid
            }, this.getHeader())
                .then(async response => {
                    ls.remove("user");
                    ls.remove("moduleAccess");
                    ls.remove("currentStep");
                    ls.remove("hasPasswordUpdated");
                    ls.remove("planId");
                    // ls.remove("token");
                    
                    resolve(response)
                })
                .catch(e => {
                    reject(e.errors);
                });
        });

        
    },
    logoutNoUser() {
        ls.remove("user");
        ls.remove("moduleAccess");
        ls.remove("currentStep");
        ls.remove("hasPasswordUpdated");
        ls.remove("planId");
        ls.remove("token");
    },
    setMerchantDetails(merchant) {
        ls.set("merchantDetails", merchant);
    },
    getMerchantDetails() {
        return ls.get("merchantDetails");
    },

    setOtpTokenId(tokenId) {
        ls.set("otpTokenId", tokenId)
    },

    setEmail(email) {
        ls.set("email", email)
    },

    setChannel(channel) {
        ls.set("channel", channel)
    },

    getOtpTokenId() {
        return ls.get("otpTokenId")
    },

    getEmail() {
        return ls.get("email")
    },

    removeOtp() {
        ls.remove("otpTokenId");
        ls.remove("email");
        ls.remove("channel");
    },

    setRefreshToken(token) {
        ls.set("refreshToken", token)
    },

    getRefreshToken() {
        return ls.get("refreshToken")
    },

    getChannel() {
        return ls.get("channel")
    },

    setHubspotToken(token) {
        ls.set("hubspotToken", token);
    },

    getHubspotToken() {
        return ls.get("hubspotToken");
    },

    login(username, password) {
        let self = this;

        return new Promise((resolve, reject) => {
            api.post("merchant-auth-service/v2/auth/login", {
                username,
                password
            })
                .then(async response => {
                    if (response.user) {
                        self.setUser(response.user);
                        self.setToken(response.token);
                        self.setRefreshToken(response.refresh_token.token);
                        self.setHasPasswordUpdated(
                            response.user.has_updated_password
                        );
                        self.setModuleAccess(response.user.cms_permissions);
                        self.setModuleAccessId(response.user.module_access_id);

                        self.setMetas(response.user.metas);
                        self.getCartLinkingSettings(response.user.merchant_uuid);

                        if (_.has(response, "hubspot_data") && _.has(response.hubspot_data, "conversation_token"))
                            self.setHubspotToken(response.hubspot_data.conversation_token);
                    } else {
                        self.setOtpTokenId(response.data.token_id);
                        self.setEmail(response.data.email);
                        self.setChannel(response.data.channel); 
                    }

                    

                    // self.getTopUpsApi();
                    // self.getMerchantDetail();
                    // self.getUserDetails(response.user.uuid);
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    getCartLinkingSettings (merchant_uuid) {
        let self = this;
        return new Promise((resolve, reject) => {
            api.get(`merchant-service/settings/cartlinking/${merchant_uuid}`, this.getHeader())
                .then(async (response) => {
                    self.setIsCartLinkingEnabled(response.enable_cartlinking.value)
                    resolve(response)
                })
                .catch(e => {
                    reject(e.errors);
                });
        })
    },

    setIsCartLinkingEnabled (isEnabled) {
        ls.set("isCartLinkingEnabled", isEnabled)
    },

    getIsCartLinkingEnabled () {
        return ls.get("isCartLinkingEnabled")
    },

    verifyOtp(otp, otpTokenId) {
        let self = this;
        return new Promise((resolve, reject) => {
            api.post(`merchant-auth-service/v2/auth/validate-2fa`, {
                otp: otp,
                token_id: otpTokenId,
            })
                .then(async (response) => {
                    self.setUser(response.user);
                    self.setToken(response.token);
                    self.setHasPasswordUpdated(
                        response.user.has_updated_password
                    );
                    self.setModuleAccess(response.user.cms_permissions);
                    self.setModuleAccessId(response.user.module_access_id);

                    self.setMetas(response.user.metas);
                    self.removeOtp();
                    if (_.has(response, "hubspot_data") && _.has(response.hubspot_data, "conversation_token"))
                        self.setHubspotToken(response.hubspot_data.conversation_token);
                    notification.success(response.message);
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        })
    },

    resendOtp(otpTokenId) {
        let self = this;
        return new Promise((resolve, reject) => {
            api.post(`merchant-auth-service/v2/auth/resend-otp`, {
                token_id: otpTokenId,
            }).then((response) => {
                self.removeOtp();
                self.setOtpTokenId(response.data.token_id);
                self.setEmail(response.data.email);
                self.setChannel(response.data.channel);
                resolve(response);
            }).catch(e => {
                reject(e.errors);
            });
        })
    },

    resetPassword(email) {
        return new Promise((resolve, reject) => {
            api.post("merchant-auth-service/auth/password/reset", {
                email
            })
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    resetToken(token) {
        return new Promise((resolve, reject) => {
            api.get("merchant-auth-service/auth/password/reset/" + token)
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    getTopUpsApi() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/settings/topups", this.getHeader())
                .then(response => {
                    resolve(response);
                    let topups = [];
                    let whitelist = "";

                    if (response.length > 0) {
                        response.forEach(function (value) {
                            // if (value.enable === true) {
                            topups.push(value.code);
                            // }
                            if (value.code === "whitelist") {
                                whitelist = value.type;
                            }
                        });
                    }
                    this.setEnabledTopUps(topups);
                    this.setWhitelistType(whitelist);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    getOnlineStoreVisibilityStatus() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/settings/online-store-visibility", this.getHeader())
                .then(response => {
                    this.setOnlineStoreVisibility(response);
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },

    getMerchantDetail() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/details", this.getHeader())
                .then(response => {
                    resolve(response);
                    this.setMerchantName(response.name);
                    this.setMerchantWebsite(response.website);
                    this.setPlanId(response.plan_id);
                    this.setMerchantDetails(response);

                    let currentStep = "step0";
                    if (response.step1 == 0 || response.step1 == false) {
                        currentStep = "step1";
                    } else if (response.step2 == 0 || response.step2 == false) {
                        currentStep = "step2";
                    } else if (response.step3 == 0 || response.step3 == false) {
                        currentStep = "step3";
                    }

                    this.setCurrentStep(currentStep);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    getUserDetails(uuid) {
      return new Promise((resolve, reject) => {
        api.get(
          `merchant-auth-service/user/view/${uuid}`,
          this.getHeader()
        ).then(response => resolve(response)).catch(e => reject(e.errors));
    });
    },
    resetModuleAccess(modules) {
        let self = this;
        self.setModuleAccess(modules);
    },
    getAdminSettings() {
        return new Promise((resolve, reject) => {
            api.get(
                "merchant-service/cms/settings/rewards-version",
                this.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
    refreshToken(token) {
        let self = this;
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-auth-service/auth/token/refresh", {
                    token: token
                })
                .then(response => {
                    self.setToken(response.token);
                    resolve(response);
                })
                .catch(e => {
                    reject(e.errors);
                });
        });
    },
};
